export const capitalize = (s: string): string => s.charAt(0).toUpperCase() + s.slice(1)

export const capitalizePhrase = (s: string): string => s.split(' ').map(capitalize).join(' ')
